export default __webpack_public_path__ + "static/media/telegram.ef111def.svg";